// Adapter between the canonical backend training proposal API and the intake UI.
// Never infer "approved" from an AI suggestion; review is a separate user action.
export function normalizeTrainingIntakeProposal(item = {}, employeeName = '') {
  const holderMatch = String(item.holder_name_match || '').toLowerCase();
  const nameMatch = item.name_match || (item.holder_name ? {
    exact_match: holderMatch === 'match',
    partial_match: holderMatch === 'partial_match',
    certificate_name: item.holder_name,
    employee_name: employeeName,
  } : null);
  return {
    ...item,
    item_id: item.item_id || item.id,
    training_title: item.training_title || item.raw_course_title || item.mapped_training_title || '',
    completion_date: item.completion_date || item.completed_at || '',
    expiry_date: item.expiry_date || item.expires_at || '',
    inferred_training_code: item.inferred_training_code || item.mapped_training_code || '',
    name_match: nameMatch,
  };
}

export function buildTrainingIntakeReviewItems(reviewDecisions = {}) {
  return Object.entries(reviewDecisions)
    .filter(([, decision]) => decision.action === 'approve' || decision.action === 'reject')
    .map(([itemId, decision]) => ({
      item_id: itemId,
      approve: decision.action === 'approve',
      ...(decision.edited ? {
        mapped_training_code: decision.values.inferred_training_code || null,
        mapped_training_title: decision.values.training_title || null,
        completed_at: decision.values.completion_date || null,
        expires_at: decision.values.expiry_date || null,
      } : {}),
    }));
}
